// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductSpecs{order:30;width:100%;margin-top:35px}@media (min-width: 768px){.ProductSpecs{margin-top:45px}}.ProductSpecs-Item{margin-bottom:7px}.ProductSpecs-Item:last-of-type{margin-bottom:0}.ProductSpecs-Item strong:after{content:': '}.ProductSpecs .ProductAttributeValue{display:inline}.product-specs td{padding:5px 1px}.product-specs th{padding:5px 1px}\n", ""]);
// Exports
module.exports = exports;
